import { render } from "./add-quotes.vue?vue&type=template&id=184ad950&scoped=true"
import script from "./add-quotes.vue?vue&type=script&lang=js"
export * from "./add-quotes.vue?vue&type=script&lang=js"

import "./add-quotes.vue?vue&type=style&index=0&id=184ad950&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184ad950"]])

export default __exports__